export enum AddEditNoteMode {
	LeaveCase = 1,
	Employer = 2,
	Employee = 3
}